export default "__VITE_ASSET__OCYSEiRf__"